export const API_BASE_URL = "https://sridevitemple.com/services/";
// export const API_BASE_URL = "./services/";
export const notification_types = {
    info : 'info',
    success : 'success',
    error : 'error',
    warning : 'warning'
}

export const image = 'https://sridevitemple.com/admin/';